import { useCallback, useEffect, useState } from 'react';
import { Car, isConfigured, listCars } from '../api/cars';

export interface UseCarsResult {
  cars: Car[];
  loading: boolean;
  error: string | null;
  configured: boolean;
  reload: () => void;
}

export const useCars = (): UseCarsResult => {
  const [cars, setCars] = useState<Car[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const configured = isConfigured();

  const load = useCallback(async () => {
    if (!configured) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      setCars(await listCars());
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not load cars');
    } finally {
      setLoading(false);
    }
  }, [configured]);

  useEffect(() => {
    load();
  }, [load]);

  return { cars, loading, error, configured, reload: load };
};
